module.exports = __webpack_public_path__ + "media/images/horse-face-e07e6f7b9c5c72efeb4d7ece2d436129.png";